import React from 'react';
import { Shield, Award, FileCheck, Clock } from 'lucide-react';

const GovernmentCredibility = () => {
  const features = [
    {
      icon: Shield,
      title: 'Security Compliant',
      description: 'Meeting highest security standards for confidential government documents and tender printing.'
    },
    {
      icon: Award,
      title: 'Government Approved Vendor',
      description: 'Registered and approved contractor for central and state government printing projects.'
    },
    {
      icon: FileCheck,
      title: 'Tender Expertise',
      description: 'Specialized in government tender document printing with strict compliance to specifications.'
    },
    {
      icon: Clock,
      title: 'On-Time Delivery',
      description: '99% on-time delivery track record for time-sensitive government projects and deadlines.'
    }
  ];

  return (
    <section className="bg-[#003151] text-white section-padding" data-testid="govt-credibility-section" aria-labelledby="govt-heading">
      <div className="container-custom">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Left: Content */}
          <article>
            <p className="text-xs font-semibold uppercase tracking-[0.15em] text-white/60 mb-4">
              Government & Enterprise Partner
            </p>
            <h2 id="govt-heading" className="text-2xl sm:text-3xl lg:text-4xl font-extrabold tracking-tight leading-tight font-heading mb-6">
              Trusted Partner for
              <br />
              Government Contracts
            </h2>
            <p className="text-white/80 leading-relaxed mb-8">
              We specialize in <strong>government contract printing</strong> with expertise in handling 
              large-scale projects for ministries, departments, PSUs, and municipal corporations. 
              Our <strong>ISO certified facility</strong> ensures compliance with all government 
              specifications and security requirements.
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
              {features.map((feature, index) => (
                <div key={index} className="flex items-start gap-3" data-testid={`govt-feature-${index}`}>
                  <div className="p-2 bg-white/10 rounded flex-shrink-0">
                    <feature.icon className="w-5 h-5" aria-hidden="true" />
                  </div>
                  <div>
                    <h3 className="font-semibold mb-1">{feature.title}</h3>
                    <p className="text-sm text-white/70">{feature.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </article>

          {/* Right: Image */}
          <figure className="overflow-hidden rounded-lg">
            <img
              src="https://images.pexels.com/photos/6620989/pexels-photo-6620989.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
              alt="Offset printing press producing high-quality documents for government contracts"
              className="w-full h-auto object-cover"
              data-testid="govt-credibility-image"
              loading="lazy"
              width="940"
              height="650"
            />
            <figcaption className="sr-only">Our offset printing press handling government printing contracts</figcaption>
          </figure>
        </div>
      </div>
    </section>
  );
};

export default GovernmentCredibility;
